export default {
    organizations: 'Grupos de trabalho',
    events: 'Eventos',
    projects: 'Projectos',
    invitations: 'Convites',
    notifications: 'Notificações',
    settings: 'Definições',
}
